import { render, staticRenderFns } from "./Sold.vue?vue&type=template&id=a3ec9fe0&scoped=true&"
import script from "./Sold.vue?vue&type=script&lang=ts&"
export * from "./Sold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ec9fe0",
  null
  
)

export default component.exports